








































































































































































































import { Component, Vue } from "vue-property-decorator";
import FlightChangeInput from "@/store/entities/flight/flightChangeInput";
import ReservationDetailModal from "./modals/reservationDetailModal.vue";
import moment from "moment";
@Component({
  components: { ReservationDetailModal },
})
export default class FlightChangeChecklist extends Vue {
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  startDate: Date = null;
  endDate: Date = null;
  breadcrumbsItems: any[] = [];
  active_tab: number = 0;
  checkbox: boolean = false;
  flightChange: FlightChangeInput = new FlightChangeInput();

  get getStartDate() {
    return this.startDate
      ? (this.flightChange.flightDateStarts = moment(this.startDate).format(
          "DD-MM-yyyy"
        ))
      : "";
  }
  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }

  created() {
    (this.headers = [
      { text: "Kalkış-Varış", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNo" },
      { text: "Kalkış Tarih & Saat", value: "departureDate" },
      { text: "Varış Tarih & Saat", value: "arrivalDate" },
      { text: "Yolcu Sayısı", value: "passenger" },
    ]),
      (this.mockData = [
        {
          destination: "AYT - KEJ ",
          flightNo: "N4 1894 ",
          departureDate: "28/04/2021 17:00 ",
          arrivalDate: "29/04/2021 04:00",
          passenger: "Yok",
        },
      ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Uçuş", disabled: true },
        { text: "Uçuş Değişim Kontrol Listesi", disabled: true },
      ]);
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }

  data() {
    return {
      page: 1,

      fromAirportsItems: ["Anapa,Rusya / AAQ", "Abakan,Rusya / ABA"],
      fromAirports: [],

      toAirportsItems: [
        "Antalya,Turkey (AYT-Antalya Int) / AYT",
        "Akabe,Urdun / AQJ",
      ],
      toAirports: [],

      wayItems: ["Tek Yön", "Çift Yön"],
      way: [],
    };
  }
}
